import React from "react";

function Loading(props) {
  return (
    <>
      <div style={{ width: "50%", margin: "200px auto" }}>
        <h1 style={{ textAlign: "center" }}>
          Loading{" "}
          <img
            src="/images/loading.gif"
            alt="loading"
            style={{ maxWidth: 25 }}
          />
        </h1>
      </div>
    </>
  );
}

export default Loading;
